<!--<script setup>-->
<!--import BreezeApplicationLogo from '@/Components/ApplicationLogo.vue';-->
<!--import { Link } from '@inertiajs/inertia-vue3';-->
<!--import Card from "primevue/card"-->
<!--</script>-->

<template>
    <div class="min-h-screen flex flex-column justify-content-center align-items-center" style="background-color: #030710">
        <div style="margin-bottom: -4px;">
<!--            <Link href="/">-->
<!--                <BreezeApplicationLogo class="w-20 h-20 fill-current text-gray-500" />-->
<!--            </Link>-->
            <img src="/images/neuro1.jpeg" style="width: 230px;"/>
        </div>
        <div class="grid w-full">
            <div class="col-4"></div>
            <div class="col-4">
                <div class="surface-card shadow-2 p-4">
                    <slot />
                </div>
            </div>
            <div class="col-4"></div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {}
    }
}
</script>
